<template>
    <div>
        <div class="bg-color">
            <b-container>
                    <Welcome/>
            </b-container> 
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import Welcome from '@/components/frontend/registered/Welcome'

    export default {
        name: 'PublicView',
        components:{ 
            Welcome
        },
        data()  {
            return {

            }
        },
        created(){

        },
        methods: {
            ...mapActions("proposal", [
                "getProposalData",
            ])
        },
        mounted() {

        }

    }
</script>



<style scoped>

    .bg {
        /* The image used for web */
        background: url("~@/assets/quick-quote-bg.png");

        /* Full height */
        height: 100%;
        overflow: hidden;
        /* Center and scale the image nicely */
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .bg-color {
        /*background-color: #f2f6fa;*/
    }

    @media (max-width: 767px) {
       .bg {
           overflow: scroll;
       }

        .app-footer {
            display: unset !important;
            text-align: center !important;
            bottom: 0!important;
            position: inherit;
            width: 100%;
        }
    }


</style>
